module.exports = __webpack_public_path__ + "static/media/KalgoorlieMiner-devicecomp-min@2x.7f4d59ba.png";